import { FC } from 'react';
import { SendWebPush24 } from 'ui/icons/aurora/24px/studio';
import { PageHeader } from 'ui/pageHeader';
import { ModalsProvider, WebPushMetadataProvider } from '../context';
import { Modals } from './Modals/Modals';
import { WebPushIntegrationTable } from './WebPushIntegrationTable';
import { PageBody, PageHeaderLabel, StyledSubheader, StyledSubtitle, TextContent } from './styles';

const withContext = (Component: FC) => () => (
  <WebPushMetadataProvider>
    <ModalsProvider>
      <Component />
      <Modals />
    </ModalsProvider>
  </WebPushMetadataProvider>
);

export const WebPush = withContext(() => {
  return (
    <>
      <PageHeader documentTitle="Web push">
        <PageHeaderLabel>
          <SendWebPush24 height={32} width={32} />
          Web push
        </PageHeaderLabel>
      </PageHeader>
      <PageBody>
        <TextContent data-test="web-push-text-content">
          <StyledSubheader>Web push</StyledSubheader>
          <StyledSubtitle>
            Set up a new web push integration by uploading your Firebase credentials.
          </StyledSubtitle>
        </TextContent>
        <WebPushIntegrationTable />
      </PageBody>
    </>
  );
});
